import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { paymentMethodMessages } from 'features/Bookings/components/PaymentMethod/messages'
import { safeFormatMessage } from 'utils/intl'

const SalesWrapper = styled.div<TSFixMe>`
  margin-top: 10px;
`

export const DrawerSales = ({ sales = [], expectedAmount, modalTitle }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      <div>
        <FormattedPrice value={expectedAmount} />
      </div>
      <SalesWrapper>
        {sales.length > 0 ? (
          <div>
            <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{sales.length}</StyledLink>
          </div>
        ) : (
          0
        )}
      </SalesWrapper>
      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>{modalTitle}</Heading.H5>
          </Modal.Header>

          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="drawer.sales.id.label" defaultMessage="Id" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.amount" defaultMessage="Amount" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.paymentMethod" defaultMessage="Payment method" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.last4" defaultMessage="last4" />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {sales.map((sale: TSFixMe, index: number): TSFixMe => {
                    return (
                      <Tr key={index}>
                        <Td>{sale.id.substring(0, 8)}</Td>
                        <Td>
                          <FormattedPrice value={sale.payment.amount} />
                        </Td>
                        <Td>
                          {safeFormatMessage({ intl, messages: paymentMethodMessages, key: sale.payment.method })}
                        </Td>
                        <Td>{!!sale.payment.last4 && sale.payment.last4}</Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
